module.exports = __webpack_public_path__ + "static/media/How to Dress for the Interview.36c456bf.pdf";